var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVectorJoinOur2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 329,
    height: 290,
    viewBox: "0 0 329 290",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 249,
    r: 271,
    fill: "#8114D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorJoinOur2);
export default __webpack_public_path__ + "static/media/vectorJoinOur2.fde61962841917191f2f6261531c0583.svg";
export { ForwardRef as ReactComponent };